/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {

    /**
     * Validates date input based on specified rules from MSA and provides label rules.
     */
    Alpine.data('dateValidator', (rules) => {

        /**
         * Validates if the input value string matches the format 'mm/dd/yyyy' and is a valid date.
         * @param {string} value - The date string to validate.
         * @returns {boolean} - True if the date is in 'mm/dd/yyyy' format and is a valid date. otherwise, false.
         */
        const validateMonthDayYear = (value) => {
            const dateRegex = /^([0-1]?[0-9]\/[0-3]?[0-9]\/[1-2][0-9]{3})$/;
            try {
                return !!Date.parse(value) && dateRegex.test(value);
            } catch (error) {
                return false;
            }
        };

        /**
         * Validates if the input date string matches the format 'mm/yyyy' and is a valid date.
         * @param {string} value - The date string to validate.
         * @returns {boolean} - true if the date is in 'mm/yyyy' format and is a valid date or false.
         */
        const validateMonthYear = (value) => {
            const dateRegex = /^([0-1]?[0-9]\/[1-2][0-9]{3})$/;
            if (!dateRegex.test(value)) return false;
            try {
                const dateParts = value.split('/');
                const testDate = `${dateParts[0]}/01/${dateParts[1]}`;
                return !!Date.parse(testDate);
            } catch (error) {
                return false;
            }
        };

        /**
         * Validates if the input string is a valid year in the format 'yyyy'.
         * @param {string} value - The string to validate as a year.
         * @returns {boolean} - true if the input is a valid year in 'yyyy' format or false.
         */
        const validateYearOnly = (value) => {
            const yearRegex = /^[1-2][0-9]{3}$/;

            return yearRegex.test(value);
        };

        /**
         * Validates if the input string is 'current'.
         *
         * @param {string} value - The string to validate.
         * @returns {boolean} - true if the input string is 'current' or false.
         */
        const validateCurrent = (value) =>
            value.toLowerCase() === constants.current_date.toLowerCase();

        /**
         * Map of validation methods corresponding to validation options.
         */
        const optionMethodMap = {
            'YEAR_ONLY': validateYearOnly,
            'MONTH_YEAR': validateMonthYear,
            'MONTH_DAY_YEAR': validateMonthDayYear,
            'CURRENT': validateCurrent
        };

        /**
         * Map of labels for each validation option.
         */
        const optionLabelsMap = {
            'YEAR_ONLY': 'yyyy',
            'MONTH_YEAR': 'mm/yyyy',
            'MONTH_DAY_YEAR': 'mm/dd/yyyy',
        };

        /**
         * Return true if value is valid according the specific rule, otherwise false.
         */
        const isValidDate = (value) => rules.some(rule => optionMethodMap[rule] && optionMethodMap[rule](value));

        return {
            /**
             * Property if value is valid according specified rules.
             */
            isValid: true,

            /**
             * Validates the date input based on specified rules.
             */
            validateDate(event) {
                if (rules.length < 1) {
                    this.isValid = true;
                    return;
                }

                this.isValid = isValidDate(event.target.value);
            },

            /**
             * Retrieves the label rules for the specified rules.
             */
            getLabelRules() {
                return rules.filter(rule => optionLabelsMap[rule])
                    .map(rule => optionLabelsMap[rule])
                    .join(', ');
            },

            /**
             * Validates x-on:focus event.
             */
            onFocus(event) {
                this.isValid = isValidDate(event.target.value);
            },

            /**
             * Hide validation message.
             */
            hide(event) {
                this.isValid = true;
            }
        }
    })
});